import { InitialReApplyDocument } from '.';

/* eslint-disable import/prefer-default-export */
export const types = {
  SAVE_RE_APPLY_DOCUMENTS: 'SAVE_RE_APPLY_DOCUMENTS' as const,
  CLEAR_RE_APPLY_DOCUMENTS: 'CLEAR_RE_APPLY_DOCUMENTS',
};

export const saveReApplyDocument = (payload: InitialReApplyDocument) => ({
  type: types.SAVE_RE_APPLY_DOCUMENTS,
  payload,
});

export const clearReApplyDocument = () => ({
  type: types.CLEAR_RE_APPLY_DOCUMENTS,
  payload: {}, // remove data doc
});

export type Actions = ReturnType<typeof saveReApplyDocument>;
